export default __webpack_public_path__ + "static/media/homeIcon.ec767e06.svg";